import { useEffect, useState, useCallback } from "react";
import {
    Page,
    LegacyCard,
    Button,
    DataTable,
    Badge,
    Modal,
    Select,
    SkeletonBodyText
} from "@shopify/polaris";
import Axios from "./common/Axios";

export function EbayAccount() {
    const [rows, setrows] = useState([])
    const [selected, setSelected] = useState("0");
    const [siteid, setSiteid] = useState(0);
    // const [selected1, setSelected1] = useState("0");
    // const [siteid1, setSiteid1] = useState(0);
    const [loadingbutton, setloadingbutton] = useState(false);
    const [loadingbutton1, setloadingbutton1] = useState(false);
    const [active, setActive] = useState(false);
    // const [active1, setActive1] = useState(false);
    // const [userId, setUserId] = useState(0);
    const [skeleton, setskeleton] = useState(false)
    const toggleModal = useCallback(() => setActive((active) => !active), []);
    // const toggleModal1 = useCallback(() => setActive1((active1) => !active1), []);
    const [loadingButtons, setLoadingButtons] = useState({});


     const savedData = localStorage.getItem("storeData");
     const localData = savedData ? JSON.parse(savedData) : null;

     const userId = localData?.user?.id ?? 0;

    const handleModalSubmit = () => {
        setloadingbutton(true)
        console.log("userId ", userId);
        console.log("siteid ", siteid);
        // return
        window.location.href = 'https://shopify.infoshore.biz/epi/authorize.php?sbkey=' + userId + '&new=new&siteid=' + siteid;
    }

    const handleModalSubmit1 = (siteIdValue) => {
        // Use the passed siteIdValue instead of siteid state
        setLoadingButtons(prev => ({ ...prev, [siteIdValue]: true }));
        console.log("userIdddd ", userId);
        console.log("siteid ", siteIdValue);
        
        // Replace this with your actual API call
        setTimeout(() => {
            setLoadingButtons(prev => ({ ...prev, [siteIdValue]: false }));
        }, 2000);
        
        // return
        window.location.href = 'https://shopify.infoshore.biz/epi/authorize.php?sbkey=' + userId + '&new=new&siteid=' + siteIdValue;
    }

    const [accountData, setAccountData] = useState([]);

    useEffect(() => {
        setskeleton(true)
    

        const fetchEbayAccounts = async () => {
            try {
                const response = await Axios.get(`${process.env.REACT_APP_API_URL}/ebayaccounts`);
                console.log("ebay account data -->> ", response.data);
                const data = response.data;
                if (Array.isArray(data) && data.length > 0) {
                    setAccountData(data);
                    // setUserId(data[0].user_id);
                }
            } catch (error) {
                console.error("Error fetching eBay accounts:", error);
            } finally {
                setskeleton(false);
            }
        }
        fetchEbayAccounts()
    }, []) // Remove loadingButtons dependency

    // Create rows from accountData and loadingButtons
    useEffect(() => {
        if (accountData.length > 0) {
            const formattedRows = accountData.map(({ sellerid, siteid, valid }, index) => [
                index + 1,
                sellerid,
                siteid,
                valid === 1
                    ? <Badge tone="success">Connected</Badge>
                    : <Badge tone="critical">Expired</Badge>,
                <Button 
                    disabled={valid == 1} 
                    loading={loadingButtons[siteid] || false}  
                    variant="primary" 
                    onClick={() => handleModalSubmit1(siteid)}
                >
                    Reconfigure
                </Button>
            ]);
            setrows(formattedRows);
        }
    }, [accountData, loadingButtons]) 

    const handleSelectChange = useCallback((value) => {
        setSelected(value);
        setSiteid(Number(value));
    }, []);

    // const handleSelectChange1 = useCallback((value) => {
    //     setSelected1(value);
    //     setSiteid1(Number(value));
    // }, []);

    const options = [
        { label: "United States", value: "0" },
        { label: "Canada", value: "2" },
        { label: "UK", value: "3" },
        { label: "Australia", value: "15" },
        { label: "Austria", value: "16" },
        { label: "Belgium (French)", value: "23" },
        { label: "France", value: "71" },
        { label: "Germany", value: "77" },
        { label: "Italy", value: "101" },
        { label: "Belgium (Dutch)", value: "123" },
        { label: "Netherlands", value: "146" },
        { label: "Spain", value: "186" },
        { label: "Switzerland", value: "193" },
        { label: "Hong Kong", value: "201" },
        { label: "Ireland", value: "205" },
        { label: "Malaysia", value: "207" },
        { label: "Canada (French)", value: "210" },
        { label: "Philippines", value: "211" },
        { label: "Poland", value: "212" },
        { label: "Singapore", value: "216" },
    ];
    const handleChange = useCallback(() => {
        setActive(!active)
        if (active) {
            // fetchDataAndInitialize()
        }
    }, [active]);

    //  const handleChange1 = useCallback(() => {
    //     setActive1(!active1)
    //     if (active1) {
    //         // fetchDataAndInitialize()
    //     }
    // }, [active1]);


    return (

        <Page title="Ebay Account"
            primaryAction={{ content: 'Add Account', onAction: toggleModal }}
        >
            <LegacyCard>
                {!skeleton ? 
                 <DataTable
                    columnContentTypes={[
                        'text',
                        'text',
                        'text',
                        'text',
                        'text',
                    ]}

                    headings={[
                        'Id',
                        'Seller Id',
                        'Site',
                        'Status',
                        'Actions'
                    ]}
                    rows={rows}
                />
                :
                <div style={{padding:"2%"}}>
                <SkeletonBodyText lines={5}/>

                </div>
               
                }
                
            </LegacyCard>
            <Modal
                open={active}
                onClose={handleChange}
                title="Add ebay account"
                primaryAction={{
                    content: 'Connect',
                    onAction: handleModalSubmit,
                    loading: loadingbutton
                }}
            >
                <Modal.Section>
                    <label
                        style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: "bold",
                        }}
                    >
                        Selling region
                    </label>
                    <Select
                        options={options}
                        onChange={handleSelectChange}
                        value={selected}
                        fullWidth
                    />
                </Modal.Section>
            </Modal>

             {/* <Modal
                open={active1}
                onClose={handleChange1}
                title="Add ebay account"
                primaryAction={{
                    content: 'Connect',
                    onAction: handleModalSubmit1,
                    loading: loadingbutton1
                }}
            >
                <Modal.Section>
                    <label
                        style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: "bold",
                        }}
                    >
                        Selling region
                    </label>
                    <Select
                        options={options}
                        onChange={handleSelectChange1}
                        value={selected1}
                        fullWidth
                    />
                </Modal.Section>
            </Modal> */}

        </Page>

    );
}

